import { API_URL } from '../config/app';

export interface GoogleReviewAuthor {
  displayName: string;
  photoUri: string;
}

export type GoogleReviewCategory = 'telephone' | 'site-web' | 'depannage' | 'autre';

export interface GoogleReview {
  authorAttribution: GoogleReviewAuthor;
  rating: number;
  text: { text: string };
  relativePublishTimeDescription: string;
  /** Date ISO de publication (tri par récence). */
  publishTime?: string | null;
  category?: GoogleReviewCategory;
}

export interface GoogleReviewsData {
  rating: number | null;
  userRatingCount: number | null;
  reviews: GoogleReview[];
}

let cachedPromise: Promise<GoogleReviewsData> | null = null;

/** Récupère les avis Google. Une seule requête partagée entre tous les consommateurs. */
export const fetchGoogleReviews = (): Promise<GoogleReviewsData> => {
  if (cachedPromise) return cachedPromise;

  const promise = (async (): Promise<GoogleReviewsData> => {
    const response = await fetch(`${API_URL}/api/google-reviews`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const json = (await response.json()) as Partial<GoogleReviewsData>;
    return {
      rating: typeof json.rating === 'number' ? json.rating : null,
      userRatingCount: typeof json.userRatingCount === 'number' ? json.userRatingCount : null,
      reviews: Array.isArray(json.reviews) ? json.reviews : [],
    };
  })();

  cachedPromise = promise;
  // Permet une nouvelle tentative au prochain appel en cas d'échec.
  promise.catch(() => {
    if (cachedPromise === promise) cachedPromise = null;
  });
  return promise;
};
